export default function getRecordUrl(uniqueFields, row, action = "view") {
    if(uniqueFields.length > 0) {
        const uniqueFieldName = uniqueFields[0];
        return `./${action}/${uniqueFieldName}/${row[uniqueFieldName]}`;
    } else {
        return `./${action}/robostack_id/${row["robostack_id"]}`;
    }
};